/*
    Create by BaiZhiming 2015-12-15
*/
'use strict';
angular
    .module('websiteServiceModule', [
        'batChooseChnlModule',
        'singleChooseChnlModule',
        'stickModule',
        'contentExpansionModule',
        'editCenWebsiteSigedPushBarModule',
        'editCenWebsiteSigedPushBarToMlfModule',
        'editWebsteSubjectViewModule',
        'editWebsteAscriptionViewModule',
        'websiteNoRepeatModule',
    ])
    .factory('websiteService', [
        '$modal',
        '$q',
        'trsHttpService',
        'modalDialog',
        'editingCenterService',
        '$state',
        function($modal, $q, trsHttpService, modalDialog, editingCenterService, $state) {
            /**
             * [getDetailUrl 获取预览页]
             *
             * @param   {[type]}  doctypeID    [doctypeID description]
             * @param   {[type]}  mediatypeID  [mediatypeID description]
             *
             * @return  {[type]}               [return description]
             */
            function getDetailUrl(doctypeID) {
                let baseUrl = window.location.origin + '/xjmediaCloud/#/';
                let previewUrl = '';
                previewUrl += `websitepreview?wzchannelid=${$state.params.wzchannelid}&wzchnldocid=${$state.params.wzchnldocid}&wzsiteid=${$state.params.wzsiteid}&wzmetadataid=${$state.params.wzmetadataid}&wzplatform=${$state.params.wzplatform}&wztypeid=${doctypeID}`;
                return baseUrl + previewUrl;
            }

            /**
             * [getOprType 获取操作平台类型]
             * @return  {[type]}  [return description]
             */
            function getOprType() {
                return {
                    '0': 'web.daibian',
                    '1': 'web.daishen',
                    '2': 'web.yiqianfa'
                }[$state.params.wzplatform] || 'website.daibian';
            }
            return {
                /**
                 * [addFuture 为控制器作用域增加通用功能]
                 *
                 * @param   {[type]}  vm              [vm description]
                 * @param   {[type]}  methodNameList  [methodNameList description]
                 *
                 * @return  {[type]}                  [return description]
                 */
                addFuture: function (vm, methodNameList) {
                    for (var i = 0; i < methodNameList.length; i++) {
                        let methodName = methodNameList[i];
                        vm[methodName] = this[methodName];
                    }
                    return vm;
                },
                /**
                 * [sendmessage 发送消息到IM]
                 *
                 * @return  {[type]}  [return description]
                 */
                sendmessage: function () {
                    let that = this;
                    this.save(true).then((data) => {
                        const outerSourceId = that.list.METADATAID;
                        const title = that.list.TITLE;
                        let articleDocType = editingCenterService.getDocTypeId();
                        let articleMediaType = editingCenterService.getEditPageMediaType();
                        let url = getDetailUrl(articleDocType);
                        const extraInfo = {
                            'articleDocType': articleDocType,
                            'articleMediaType': articleMediaType,
                            'articleUrl': url,
                            'metadataid': outerSourceId,
                            'isawaitrevise': $state.params.isawaitrevise ? true : false,
                            'siteid': $state.params.wzsiteid,
                            'doctypeid': articleDocType,
                            'channelid': $state.params.wzchannelid,
                            'chnldocid': $state.params.wzchnldocid
                        };
                        const info = {
                            messageBody: {
                                content: '',
                                extraInfo: JSON.stringify(extraInfo),
                                messageType: 'ARTICLE_DOC', 
                                outerSourceId: outerSourceId,
                                platform: '',
                                title: title
                            },
                            outerSourceId: '',
                            oprType: getOprType(),
                            objId: $state.params.wzchannelid
                        };
                        editingCenterService.sendToStudio(info).then(function(result){
                            if (result.ISSUCCESS === 'true') {
                                setTimeout(() => {
                                    window.close();
                                }, 2000);
                            }
                        });
                    });
                },
                /**
                 * [batChooseChnl description]批量选择站点
                 * @param  {[string]} modalTitle [description]弹框标题
                 * @param  {[string]} siteid [description]站点ID
                 * @param  {[fn]} success [description]回调函数
                 * @param  {[radio]} radio [description]附件单选框组  非必传
                 * @return {[null]}     [description]
                 */
                batChooseChnl: function (modalTitle, siteid, platform, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/batChooseChnl/batChooseChnl_tpl.html',
                        windowClass: 'website-batChooseChnl-window',
                        backdrop: false,
                        controller: 'batChooseChnlCtrl',
                        resolve: {
                            chnlParams: function() {
                                return {
                                    siteid: siteid,
                                    modalTitle: modalTitle,
                                    platform: platform,
                                    // radio: radio,

                                    /* "channelid": channelid,
                                    "METADATAIDS": METADATAIDS,
                                    "methodname": methodname*/
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                singleChooseChnl: function(modalTitle, siteid, channelid, channelids, platform, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/singleChooseChnl/singleChooseChnl_tpl.html',
                        windowClass: 'website-move-window',
                        backdrop: false,
                        controller: 'singleChooseChnlCtrl',
                        resolve: {
                            draftParams: function() {
                                return {
                                    channelids: channelids,
                                    siteid: siteid,
                                    channelid: channelid,
                                    modalTitle: modalTitle,
                                    platform: platform,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                contentExpansion: function(items, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/contentExpansion/contentExpansion_tpl.html',
                        windowClass: 'website-contentExpansion-window',
                        backdrop: false,
                        controller: 'contentExpansionCtrl',
                        resolve: {
                            draftParams: function() {
                                return {
                                    items: items,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                stick: function(item, channelid, params, pagesize, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/stick/stick_tpl.html',
                        windowClass: 'stick-window',
                        backdrop: false,
                        controller: 'stickCtrl',
                        resolve: {
                            stickParams: function() {
                                return {
                                    item: item,
                                    channelid: channelid,
                                    params: params,
                                    pagesize: pagesize,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        if (result === 'success') {
                            success();
                        }
                    });
                },
                pushBar: function(title, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/pushBar/pushBar_tpl.html',
                        windowClass: 'editCen-website-signed-pushBar',
                        backdrop: false,
                        controller: 'editCenWebsiteSigedPushBarCtrl',
                        resolve: {
                            title: function() {
                                return title;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                pushBarToMlf: function(title, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/pushBar/pushBar_tpl.html',
                        windowClass: 'editCen-website-signed-pushBar',
                        backdrop: false,
                        controller: 'editCenWebsiteSigedPushBarToMlfCtrl',
                        resolve: {
                            title: function() {
                                return title;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                getEditandPreviewPath: function() {
                    var path = {
                        edit: {
                            1: 'websitenews',
                            2: 'websiteatlas',
                            3: 'websitesubject',
                            4: 'websitelinkdoc',
                            7: 'websitevideo',
                        },
                        preview: {
                            1: 'websiteNewsPreview',
                            2: 'websiteAtlasPreview',
                            3: 'websitesubject',
                            4: 'websiteLinkPreview',
                        },
                    };
                    return path;
                },

                /**
                 * [websitePublish description]网站下的站点或栏目发布
                 * @param   {[str]}  ObjectId      [ObjectId description]站点或栏目ID
                 * @param   {[str]}  ObjectType    [ObjectType description]站点或栏目类型
                 * @param   {[type]}  TopChannelId  [TopChannelId description]
                 * @return  {[type]}                [return description]
                 */
                websitePublish: function(ObjectId, ObjectType, TopChannelId) {
                    var publishParams = {
                        serviceid: 'mlf_publish',
                        methodname: 'soloPublish',
                        ObjectIds: ObjectId,
                        ObjectType: ObjectType,
                    };
                    if (TopChannelId) {
                        publishParams.TopChannelId = TopChannelId;
                    }
                    // 2020-01-15 将post请求改为get请求
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), publishParams, 'get').then(function(data) {
                        modalDialog.alertType('发布成功', '', 'success', false);
                    });
                },

                /**
                 * [websiteChannelPreview description]网站栏目预览（管理配置与策划中心网站都有）
                 * @param  {[type]} chl [description]栏目信息
                 * @return {[type]}     [description]
                 */
                websiteChannelPreview: function(chl) {
                    var preParams = {
                        serviceid: 'mlf_publish',
                        methodname: 'preview',
                        ObjectIds: chl.CHANNELID,
                        ObjectType: '101',
                        TopChannelId: '0',
                    };
                    if (chl.TOPCHNLID) {
                        preParams.TopChannelId = chl.TOPCHNLID == chl.CHANNELID ? 0 : chl.TOPCHNLID;
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), preParams, 'post').then(function(data) {
                        window.open(data.DATA[0].URLS[0]);
                    });
                },
                subjectModel: function(metadataId, channelid, hasChoose, successFn) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/subject/subject_tpl.html',
                        windowClass: 'website-subject-view-window',
                        backdrop: false,
                        controller: 'editWebsteSubjectViewCtrl',
                        resolve: {
                            params: function() {
                                return {
                                    metadataId: metadataId,
                                    channelid: channelid,
                                    hasChoose: hasChoose,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        successFn(result);
                    });
                },
                ascriptionModel: function(metadataId, successFn) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/ascription/ascription_tpl.html',
                        windowClass: 'website-ascription-view-window',
                        backdrop: false,
                        controller: 'editWebsteAscriptionViewCtrl',
                        resolve: {
                            params: function() {
                                return {
                                    metadataId: metadataId,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        successFn(result);
                    });
                },

                /**
                 * [afterSigning description]签发后的处理
                 *
                 * @param   {[type]}  result      [result description]签发结果数据
                 * @param   {[type]}  methodName  [methodName description]排重方法名称
                 * @param   {[type]}  noAlert     [noAlert description]不再弹出警告窗口
                 *
                 * @return  {[type]}              [return description]
                 */
                afterSigning: function(result, methodName, noAlert) {
                    var deffer = $q.defer();
                    handle(result);

                    /**
                     * [handle description] 排重的具体处理逻辑
                     * @param {objefct} [result] [description] 返回结果参数
                     * @return {[type]} [description]
                     */
                    function handle(result) {
                        var options = {
                            params: {
                                serviceid: 'mlf_websiteoper',
                                methodname: methodName,
                                enforcement: '1',
                            },
                            callback: function(params, array) {
                                var chnldocIDs = array.map(function(value, index) {
                                    return value.DOC.CHNLDOCID;
                                }).join(',');
                                var metadataIds = array.map(function(value, index) {
                                    return value.DOC.METADATAID;
                                }).join(',');
                                params.ObjectIds = chnldocIDs;
                                params.ChnlDocIds = chnldocIDs;
                                params.MetaDataIds = metadataIds;
                            },
                        };
                        editingCenterService.issuedByForce(result.errorData || result, options).then(function(result) {
                            if (result) {
                                deffer.resolve();
                            } else {
                                deffer.reject();
                            }
                        });
                    }

                    return deffer.promise;
                },

                /**
                 * [initEditPath description]初始化待编权限类型
                 * @return {[type]} [description]
                 */
                initDaiBianBtnRight: function() {
                    var btnRights = {
                        0: { RIGHTINDEX: '720', OPERNAME: 'web.daibian.chakan' },
                        1: { RIGHTINDEX: '102', OPERNAME: 'web.daibian.xinjian' },
                        2: { RIGHTINDEX: '103', OPERNAME: 'web.daibian.bianji' },
                        3: { RIGHTINDEX: '104', OPERNAME: 'web.daibian.yulan' },
                        4: { RIGHTINDEX: '105', OPERNAME: 'web.daibian.songshen' },
                        5: { RIGHTINDEX: '106', OPERNAME: 'web.daibian.qianfa' },
                        6: { RIGHTINDEX: '108', OPERNAME: 'web.daibian.yidong' },
                        7: { RIGHTINDEX: '109', OPERNAME: 'web.daibian.fuzhi' },
                        8: { RIGHTINDEX: '110', OPERNAME: 'web.daibian.fagaodan' },
                        9: { RIGHTINDEX: '111', OPERNAME: 'web.daibian.feigao' },
                        10: { RIGHTINDEX: '112', OPERNAME: 'web.daibian.waifa' },
                        11: { RIGHTINDEX: '113', OPERNAME: 'web.daibian.shoucang' },
                        // 12: { RIGHTINDEX: '277', OPERNAME: 'web.daibian.daoru' },
                        13: { RIGHTINDEX: '532', OPERNAME: 'web.daibian.fenxiang' },
                        14: { RIGHTINDEX: '41', OPERNAME: 'web.daibian.xiuding' },
                        15: { RIGHTINDEX: '326', OPERNAME: 'web.daibian.transmit' },
                    };
                    angular.forEach(btnRights, function(value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },

                /**
                 * [initEditPath description]初始化待审权限类型
                 * @return {[type]} [description]
                 */
                initDaiShenBtnRight: function() {
                    var btnRights = {
                        0: { RIGHTINDEX: '721', OPERNAME: 'web.daishen.chakan' },
                        1: { RIGHTINDEX: '120', OPERNAME: 'web.daishen.bianji' },
                        2: { RIGHTINDEX: '121', OPERNAME: 'web.daishen.yulan' },
                        3: { RIGHTINDEX: '122', OPERNAME: 'web.daishen.qianfa' },
                        4: { RIGHTINDEX: '798', OPERNAME: 'web.daishen.xcbsh' },
                        5: { RIGHTINDEX: '123', OPERNAME: 'web.daishen.tuigao' },
                        6: { RIGHTINDEX: '125', OPERNAME: 'web.daishen.yidong' },
                        7: { RIGHTINDEX: '126', OPERNAME: 'web.daishen.fuzhi' },
                        8: { RIGHTINDEX: '127', OPERNAME: 'web.daishen.fagaodan' },
                        9: { RIGHTINDEX: '128', OPERNAME: 'web.daishen.waifa' },
                        10: { RIGHTINDEX: '129', OPERNAME: 'web.daishen.shoucang' },
                        11: { RIGHTINDEX: '414', OPERNAME: 'web.daishen.check' },
                        12: { RIGHTINDEX: '533', OPERNAME: 'web.daishen.fenxiang' },
                        13: { RIGHTINDEX: '70', OPERNAME: 'web.daishen.xiuding' },
                        14: { RIGHTINDEX: '327', OPERNAME: 'web.daishen.transmit' },
                    };
                    angular.forEach(btnRights, function(value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },

                /**
                 * [initEditPath description]初始化已签发权限类型
                 * @return {[type]} [description]
                 */
                initQianFaBtnRight: function() {
                    var btnRights = {
                        0: { RIGHTINDEX: '722', OPERNAME: 'web.yiqianfa.chakan' },
                        1: { RIGHTINDEX: '131', OPERNAME: 'web.yiqianfa.bianji' },
                        2: { RIGHTINDEX: '132', OPERNAME: 'web.yiqianfa.yulan' },
                        3: { RIGHTINDEX: '134', OPERNAME: 'web.yiqianfa.chegao' },
                        4: { RIGHTINDEX: '138', OPERNAME: 'web.yiqianfa.yidong' },
                        5: { RIGHTINDEX: '139', OPERNAME: 'web.yiqianfa.duoqian' },
                        6: { RIGHTINDEX: '140', OPERNAME: 'web.yiqianfa.fuzhi' },
                        7: { RIGHTINDEX: '141', OPERNAME: 'web.yiqianfa.waifa' },
                        8: { RIGHTINDEX: '142', OPERNAME: 'web.yiqianfa.shoucang' },
                        9: { RIGHTINDEX: '143', OPERNAME: 'web.yiqianfa.gaojianpaixu' },
                        10: { RIGHTINDEX: '42', OPERNAME: 'web.yiqianfa.guanzhu' },
                        11: { RIGHTINDEX: '276', OPERNAME: 'web.yiqianfa.zhiding' },
                        12: { RIGHTINDEX: '835', OPERNAME: 'web.yiqianfa.fixedpostion' },
                        13: { RIGHTINDEX: '712', OPERNAME: 'web.yiqianfa.baocunandpublish' },
                        14: { RIGHTINDEX: '573', OPERNAME: 'web.yiqianfa.tenantshare' },
                        15: { RIGHTINDEX: '147', OPERNAME: 'web.yiqianfa.widgetbianji' },
                        16: { RIGHTINDEX: '148', OPERNAME: 'web.yiqianfa.widgetfabu' },
                        17: { RIGHTINDEX: '328', OPERNAME: 'web.yiqianfa.transmit' },
                    };
                    angular.forEach(btnRights, function(value, key) {
                        btnRights[value.OPERNAME] = value;
                    });
                    return btnRights;
                },


                /**
                 * [noRepeat description] 排重弹窗
                 * @param {Array} [items] [description] 稿件排重信息
                 * @param {String} [methodName] [description] 排重方法名称
                 * @return {[type]} [description]
                 */
                noRepeat: function(items, methodName) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/website/service/noRepeat/noRepeat_tpl.html',
                        windowClass: 'no_repeat',
                        backdrop: false,
                        controller: 'websiteNoRepeatCtrl',
                        resolve: {
                            items: function() {
                                return items;
                            },
                            methodName: function() {
                                return methodName;
                            },
                        },
                    });
                    modalInstance.result.then(
                        function() {
                            deffer.resolve();
                        },
                        function() {
                            deffer.reject();
                        },
                    );
                    return deffer.promise;
                },
                /**
                 * [resetPicSize description] 后端返回undefined或空的按16:9
                 * @return {[type]} [description]
                 */
                resetPicSize: function(str) {
                    if (str === '') {
                        return '16,9';
                    } else {
                        var strArr = str.split(',');
                        if (strArr[0] == 'undefined' || strArr[0] == '' || strArr[1] == 'undefined' || strArr[1] == '') {
                            return '16,9';
                        } else {
                            return str;
                        }

                    }
                },
            };
        },
    ]);
